<template>
  <div>
    <div class="back-top" @click="backTop" v-if="btnFlag"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      btnFlag: false,
      scroll: false
    };
  },
  methods: {
    backTop() {
      const that = this;
      const timer = setInterval(() => {
        const ispeed = Math.floor(-that.scrollTop / 5);
        document.body.scrollTop = that.scrollTop + ispeed;
        document.documentElement.scrollTop = document.body.scrollTop;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    scrollToTop() {
      const that = this;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 0) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
    window.onscroll = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop) {
        this.scroll = true;
      } else {
        this.scroll = false;
      }
    };
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop);
  }
};
</script>

<style lang="scss" scoped>
  .back-top {
    position: fixed;
    bottom: 125px;
    right: 54px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    border: solid 1px #f7f7fa;
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    background-color: #ffffff;
    background-image: url("../../assets/img/back-top2.svg") ;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    &:hover{
      background-color: #45a8cc;
      background-image: url("../../assets/img/back-top2-hover.svg") ;
    }
  }
</style>



